const documentsAndWebpagesDescriptor = Object.freeze({
    type: 'documents-and-webpages',
    version: 1,
    defaultTitleKey: 'Page(ReceivedRequest):Component(DocumentsAndWebpages):title',
    fallbackTitle: 'Documents and webpages',
    defaultNavigationTitleKey: 'Page(ReceivedRequest):Component(DocumentsAndWebpages):navigation-title',
    fallbackNavigationTitle: 'Documents and webpages',
    defaultDescriptionKey: 'Page(ReceivedRequest):Component(DocumentsAndWebpages):description',
    fallbackDescription: 'Upload available compliance documents or add links. Chemity will extract the relevant information for your review.',
    capabilities: {
        repeatable: false,
        supportedModes: ['single', 'bulk'],
        supportsReadOnly: false,
        contributesToReply: true,
    },
    dataScopes: {
        reads: [
            'request.reply-documents',
            'request.reply-documentation-links',
            'research.document-research',
        ],
        writes: [
            'request.reply-documents',
            'request.reply-documentation-links',
            'research.document-research',
        ],
    },
    effects: {
        publishes: [
            'request.reply-documents.changed',
            'request.reply-document-processing.completed',
            'request.reply-documentation-links.changed',
        ],
        observes: [],
    },
    settingsSchema: {
        type: 'object',
        additionalProperties: false,
        properties: {
            acceptedExtensions: {
                type: 'array',
                items: { type: 'string' },
                default: ['pdf'],
            },
            multipleFiles: { type: 'boolean', default: true },
            showWebpageLinks: { type: 'boolean', default: true },
            reviewProfile: {
                type: 'string',
                enum: [
                    'received-request-document-review',
                    'received-request-guided-document-review',
                ],
                default: 'received-request-guided-document-review',
            },
            researchReviewProfile: {
                type: 'string',
                enum: [
                    'received-request-guided-document-research-review',
                ],
                default: 'received-request-guided-document-research-review',
            },
            productLookupMode: {
                type: 'string',
                enum: ['organization-products', 'supplier-products'],
                default: 'organization-products',
            },
        },
    },
    settingsUi: {
        acceptedExtensions: { control: 'tags' },
        multipleFiles: { control: 'switch' },
        showWebpageLinks: { control: 'switch' },
        reviewProfile: { control: 'select' },
        researchReviewProfile: { control: 'select' },
        productLookupMode: { control: 'select' },
    },
})

export { documentsAndWebpagesDescriptor }
export default documentsAndWebpagesDescriptor
